export const lightModeColors = {
    textColor: 'black',
    backgroundColor: '#e3e3e3',
    cardColor: '#fff'
  };
  
  export const darkModeColors = {
    textColor: 'white',
    backgroundColor: '#333',
    cardColor: '#444'
  };
  